import { html, View } from 'rune-ts';
import { MyPageCommissionWidget } from '@marpple/mco-membership-ui';
import { MyMembershipTabData } from '../../../../../../../modules/MShop/App/Mypage/MembershipList/S/type';
import { MembershipErrorEnable } from '../../../../../features/Membership/error/error_enable';
import { MShopUtilF } from '../../../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { EXCLUDE_MAKER_MODULE } from '../../../../../shared/constant';
import { getActivatedSdkWithEvent } from '../../../../../features/Membership/util';
import { MembershipUtilS } from '../../../../../features/Membership/outbound/share';
import { ConfigSentryF } from '../../../../../../../modules/Config/Sentry/F/Function/module/ConfigSentryF';
import { navigateTo } from '../../../../../shared/app/util';
import {
  MEMBERSHIP_UI_IDENTIFIER,
  my_membership_commission_path,
} from '../../../../../features/Membership/constant';
import { makeEmptyScreenNavigate, makeSubScreenNavigate } from '../../../../../shared/app/navigate';
import klass from './MyCommissionDetail.module.scss';

export class CommissionTab extends View<MyMembershipTabData> {
  private _membershipErrorEnable = new MembershipErrorEnable(this);

  get isMobile(): boolean {
    return this.data.layout_options.is_mobile;
  }

  get isApp(): boolean {
    return MShopUtilF.isApp();
  }

  override async onRender() {
    try {
      const client = await getActivatedSdkWithEvent(this.data.membership_token);
      const widget = new MyPageCommissionWidget({
        client,
        isMobile: this.isMobile,
        isApp: this.isApp,
        toggleSpinner: MembershipUtilS.toggleSpinner,
        onError: this._membershipErrorEnable.onError,
        onScrollLock: MShopUtilF.bodyFixed$,
        onSeeCommissionDetailButtonClick: this.onSeeCommissionDetailButtonClick.bind(this),
        onShopButtonClick: this._onShopButtonClick.bind(this),
      });

      widget.render(this.element());
    } catch (e) {
      ConfigSentryF.error(e);
      await this._membershipErrorEnable.openWidgetRenderErrorModal();
    }
  }

  private _onShopButtonClick(shopUrl: string) {
    navigateTo(shopUrl, makeEmptyScreenNavigate);
  }

  onSeeCommissionDetailButtonClick(commissionRequestId: string): void {
    navigateTo(
      `/${ET.lang}/@/${my_membership_commission_path}/${commissionRequestId}`,
      makeSubScreenNavigate,
    );
  }

  protected override template() {
    return html`<div class="${klass.commission} ${MEMBERSHIP_UI_IDENTIFIER} ${EXCLUDE_MAKER_MODULE}"></div>`;
  }
}
